import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { Button } from '@airtm/airtm-ui';
import { LOCAL_STORAGE, PLAYSTORE_LINK } from '@constants';
import playstoreEs from 'assets/images/logo-playstore-es.svg';
import playstoreEn from 'assets/images/logo-playstore-en.svg';
import playstorePT from 'assets/images/logo-playstore-pt.svg';
import getBrowserUtmData from 'utils/getBrowserUtmData';
import qs from 'query-string';

const playstoreLogoSrc = {
  es: playstoreEs,
  en: playstoreEn,
  pt: playstorePT,
};

function PlaystoreButton({ className }) {
  const { i18n } = useTranslation();
  const classes = cx('p-0', className);

  const link = useMemo(() => {
    const referrer = localStorage.getItem(LOCAL_STORAGE.ANDROID_REFERRER);
    const utmData = getBrowserUtmData();

    const params = qs.stringify(
      {
        hl: i18n.language,
        ...(referrer && { referrer }),
        ...utmData,
      },
      { encode: true },
    );

    return `${PLAYSTORE_LINK}&${params}`;
  }, [i18n.language]);

  return (
    <Button
      component="a"
      variant="tertiary"
      className={classes}
      target="_blank"
      rel="noopener noreferrer"
      href={link}
      data-testid="google-play-login"
    >
      <img src={playstoreLogoSrc[i18n.language]} className="u-h50" alt="logo playstore" />
    </Button>
  );
}

PlaystoreButton.propTypes = {
  className: PropTypes.string,
};

PlaystoreButton.defaultProps = {
  className: null,
};

export default PlaystoreButton;
